export enum DashboardClosedByPOCPivotMode {
    Committed = 'Committed',
    Number = 'Number',
}
